import React, { useEffect, useState, useContext, useMemo } from 'react';
import '../../MailMultOperPanel/MailMultOperPanel.scss';
import FolderLogo from '../../MailMultOperPanel/FolderLogo';
import useMailStore from '@web-mail/hooks/useMailStoreRedux';
import { getCheckedMails } from '@web-mail/utils/mail';
import { useState2SubordinateSlice, SdSliceContext } from '@web-mail/hooks/useState2SliceRedux';
import { getIn18Text } from 'api';
import SuborbinateAIBtn from './SuborbinateAIBtn';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
const transformMailInfo = (mailEntryModels, subordinateList) => {
    const idJson = {};
    subordinateList === null || subordinateList === void 0 ? void 0 : subordinateList.forEach(subordinate => {
        idJson[subordinate.id] = subordinate;
    });
    return mailEntryModels.map(mail => {
        var _a, _b;
        const regex = /<\/?b>/g;
        const { size, entry, id, sender, receiver, tpMailInfo } = mail || {};
        const { title, tid, brief, sendTime, attachment } = entry || {};
        const { belongEmail, colleagueAccId, receiverSD } = tpMailInfo || {};
        const from = `${((_b = (_a = sender.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contactName) || sender.originName}<${sender.contact.contact.hitQueryEmail || sender.contact.contact.accountName}>`;
        const receiverStrs = receiver.map(i => {
            var _a, _b;
            return `${((_b = (_a = i.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contactName) || i.originName}<${i.contact.contact.hitQueryEmail || i.contact.contact.accountName}>`;
        });
        const owners = receiverSD === null || receiverSD === void 0 ? void 0 : receiverSD.map(contact => { var _a, _b, _c, _d; return `${((_a = contact === null || contact === void 0 ? void 0 : contact.parsed[0]) === null || _a === void 0 ? void 0 : _a.name) || ((_c = (_b = contact === null || contact === void 0 ? void 0 : contact.parsed[0]) === null || _b === void 0 ? void 0 : _b.email) === null || _c === void 0 ? void 0 : _c.split('@')[0])} <${(_d = contact === null || contact === void 0 ? void 0 : contact.parsed[0]) === null || _d === void 0 ? void 0 : _d.email}>`; });
        const owner = colleagueAccId && idJson[colleagueAccId] ? `${idJson[colleagueAccId].nickName} <${idJson[colleagueAccId].email}>` : '';
        const attachments = attachment === null || attachment === void 0 ? void 0 : attachment.map(attach => {
            const { fileName, id, fileSize } = attach || {};
            return Object.assign(Object.assign({}, attach), { fileName, partId: id, absolutePartId: id, contentLength: fileSize });
        });
        return {
            belongEmail,
            from,
            to: receiverStrs.join(','),
            id: id || entry.id,
            owner,
            owners: owners || (owner ? [owner] : []),
            ownerId: colleagueAccId,
            sentDate: sendTime,
            sentTime: sendTime && +new Date(sendTime),
            subject: title.replace(regex, ''),
            summary: (brief || '').replace(regex, ''),
            size,
            tid,
            attachments,
        };
    });
};
const SubordinateMailMultiOperPanel = () => {
    const [mailCount, setMailCount] = useState(0);
    const sliceId = useContext(SdSliceContext);
    const [mailDataList] = useMailStore('mailDataList', undefined, sliceId, 'subordinate');
    const [searchList] = useMailStore('searchList', { key: 'search', exclude: ['entry.title', 'receiver', 'entry.brief'] }, sliceId, 'subordinate');
    const [mailSearchState] = useState2SubordinateSlice('mailSearchState');
    const [activeIds, setActiveIds] = useState2SubordinateSlice('activeIds');
    const [, setAiAssistSideBarVisiable_sd] = useState2RM('aiAssistSideBarVisiable_sd', 'doUpdateAiAssistVisiable_sd');
    const [aiAssistSideBarEnable_sd] = useState2RM('aiAssistSideBarEnable_sd');
    const mailList = useMemo(() => (!!mailSearchState ? searchList : mailDataList), [mailSearchState, mailDataList, searchList]);
    const [subordinateList] = useState2SubordinateSlice('subordinateList');
    useEffect(() => {
        const checkedMails = getCheckedMails(activeIds, mailList);
        setMailCount(checkedMails.length);
    }, [activeIds, mailList]);
    const handleClick = () => {
        const checkedMails = getCheckedMails(activeIds, mailList);
        const data = transformMailInfo(checkedMails, subordinateList);
        setAiAssistSideBarVisiable_sd({
            visiable: true,
            type: 'mails',
            data,
            time: +new Date(),
        });
    };
    return (React.createElement("div", { className: "u-read-wrapper", style: {
            height: '100%',
        } },
        React.createElement("div", { className: "mail-mop-wrap" },
            React.createElement("div", { className: "mop-contetn" },
                React.createElement("div", { className: "detail-wrap" },
                    React.createElement("div", { className: "logo-wrap" },
                        React.createElement(FolderLogo, { sum: mailCount })),
                    React.createElement("div", { className: "num-wrap" },
                        React.createElement("div", { className: "num" }, mailCount),
                        React.createElement("div", { className: "tip" }, getIn18Text('YIXUANZEYOUJIAN')))),
                React.createElement("div", { className: "oper-wrap" }, aiAssistSideBarEnable_sd && React.createElement(SuborbinateAIBtn, { text: getIn18Text('SHISHIDUIXZDYJJXAWD'), handleClick: handleClick }))))));
};
export default SubordinateMailMultiOperPanel;
